import { forwardRef } from "react";
import { ColorPicker } from "@etframework/ui.components";

export const StageColorPicker = forwardRef(
  ({ colorLabel, color, id, change }, ref) => {
    return (
      <>
        <div className="stage-color-label">
          <span>{colorLabel}</span>
        </div>
        <ColorPicker
          ref={ref}
          id={id}
          value={color}
          change={(e) => {
            ref.current.setShowError(false);
            change?.(e);
          }}
        />
      </>
    );
  }
);
